const PHONE = '905055600419';

const serviceAreas = ['İstanbul Anadolu Yakası', 'Yalova', 'Karamürsel', 'Kocaeli', 'İzmit'];

export default function FinalCTA() {
  return (
    <section className="py-20 md:py-28 bg-slate-900 relative overflow-hidden">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-96 h-96 bg-sky-400 rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-10 w-80 h-80 bg-emerald-400 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block bg-sky-500/20 text-sky-300 text-sm font-semibold px-4 py-1.5 rounded-full mb-5">
          Son Adım
        </span>
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-5">
          Randevu ve Bilgi İçin<br className="hidden sm:block" /> Hemen Ulaşın
        </h2>
        <p className="text-slate-400 text-lg mb-10 max-w-xl mx-auto">
          18 yıllık tecrübemiz ve profesyonel ekibimizle en kısa sürede hizmetinizdeyiz.
        </p>

        {/* Phone Numbers */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
          <a
            href="tel:05055600419"
            className="inline-flex items-center justify-center gap-3 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-bold px-8 py-4 rounded-full transition-all text-lg whitespace-nowrap"
          >
            <i className="ri-phone-fill text-sky-400 text-xl" />
            0505 560 04 19
          </a>
        </div>

        {/* WhatsApp */}
        <a
          href={`https://wa.me/${PHONE}?text=${encodeURIComponent('Merhaba, randevu almak istiyorum.\n\nAd Soyad:\nTelefon:\nKonum:\nTarih:\nSaat:')}`}
          target="_blank"
          rel="nofollow noreferrer"
          className="inline-flex items-center justify-center gap-3 bg-emerald-500 hover:bg-emerald-400 text-white font-bold px-10 py-4 rounded-full transition-all text-lg mb-12 whitespace-nowrap"
        >
          <i className="ri-whatsapp-line text-xl" />
          WhatsApp ile Randevu Al
        </a>

        {/* Service Areas */}
        <div>
          <p className="text-slate-500 text-sm mb-4 font-medium uppercase tracking-widest">Hizmet Bölgelerimiz</p>
          <div className="flex flex-wrap justify-center gap-3">
            {serviceAreas.map((area) => (
              <span key={area} className="inline-flex items-center gap-1.5 bg-white/5 border border-white/10 text-slate-300 text-sm px-4 py-2 rounded-full">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-2-line text-sky-400 text-xs" />
                </div>
                {area}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
